import { supabase } from '../supabaseClient'

/**
 * Baixa o PDF assinado na Clicksign (Edge Function clicksign-baixar-assinado).
 * @param {{ envelopeId: string, documentId: string }} params — valores de document_key e clicksign_document_id em procuracao_clicksign_envios
 * @returns {Promise<{ success: boolean, pdf_base64?: string, filename?: string, error?: string }>}
 */
export async function baixarPdfAssinadoClicksign({ envelopeId, documentId }) {
  try {
    const { data, error } = await supabase.functions.invoke('clicksign-baixar-assinado', {
      body: {
        envelope_id: String(envelopeId || '').trim(),
        document_id: String(documentId || '').trim()
      }
    })
    if (error) {
      return { success: false, error: error.message || 'Falha ao chamar o serviço de download.' }
    }
    if (data && data.success === false) {
      return { success: false, error: data.error || 'Não foi possível baixar o documento assinado.' }
    }
    if (!data?.success || !data.pdf_base64) {
      return { success: false, error: data?.error || 'Resposta inválida do servidor.' }
    }
    return {
      success: true,
      pdf_base64: data.pdf_base64,
      filename: data.filename || 'documento_assinado.pdf'
    }
  } catch (e) {
    console.error('[clicksignBaixarAssinado]', e)
    return { success: false, error: e?.message || 'Erro inesperado ao baixar.' }
  }
}
